import React, { useState, useEffect } from 'react'
import { GlassesOutline, SearchOutline } from 'react-ionicons'
import { Divider } from '@/components/elements/Divider'
import { Link } from '@/components/elements/Link'
import { IonIcon } from '@/src/icons'

export interface Item {
  id: string
  name: string
  city: string
}

export interface Group {
  id: string
  title: string
  items: Item[]
}

export interface CinemasProps {
  cinemas: Group[]
}

const NoResultsFound = (): JSX.Element => (
  <div className="flex flex-col items-center my-20">
    <IonIcon className="mr-2 w-28" icon={GlassesOutline} />
    <h3 className="text-center text-4xl font-black leading-none">
      Sense resultats
    </h3>
    <p className="mt-4 max-w-xl text-center text-navy-light-600 font-body">
      No hi ha cap coincidència amb els filtres aplicats. Prova fer una altra
      combinació o contacta’ns per si et podem ajudar
    </p>
  </div>
)

export const Cinemas: React.FC<CinemasProps> = ({ cinemas }) => {
  const [searchValue, setSearchValue] = useState('')
  const [searchResults, setSearchResults] = useState(cinemas)
  const handleSearchItems = (value) => {
    setSearchValue(value)
  }

  useEffect(() => {
    const results = []
    cinemas.forEach((cinema) => {
      const matchItems = cinema.items.filter(
        (item) =>
          item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.city.toLowerCase().includes(searchValue.toLowerCase())
      )
      if (matchItems.length > 0) {
        const result = {
          ...cinema,
          items: matchItems,
        }
        results.push(result)
      }
    })

    setSearchResults(results)
  }, [searchValue, cinemas])

  return (
    <div className="flex flex-col mt-11 md:mt-16">
      <div className="relative self-center">
        <IonIcon
          className="absolute left-4 top-3.5 w-5 text-navy-light-600"
          icon={SearchOutline}
        />
        <input
          type="text"
          id="one"
          placeholder="Municipi / Sala de cinema"
          value={searchValue}
          onChange={(e) => handleSearchItems(e.target.value)}
          className="placeholder-navy-light-600 pl-12 pr-2 py-3 w-full text-navy-light-600 bg-navy-light-50 border-0 focus:border-notifiers-focus rounded focus:outline-none focus:ring md:w-80"
        />
      </div>
      {searchResults.length ? (
        searchResults.map((group) => {
          if (group.items.length) {
            return (
              <div key={`${group.id}-group`} className="mt-12">
                <h4 className="mb-4 text-3xl font-black">{group.title}</h4>
                <ul>
                  <li className="hidden mb-4 text-navy-light-600 font-semibold md:flex">
                    <span className="max-w-80 w-80">Sala</span>
                    <span>Població</span>
                  </li>
                  {group.items.map((item) => (
                    <>
                      <li key={`${item.id}-cinema`}>
                        <Link variant="secondary" href={`/cinemes/${item.id}`}>
                          <div className="flex flex-col gap-y-1 text-lg md:flex-row">
                            <span className="max-w-80 w-80 font-semibold">
                              {item.name}
                            </span>
                            <span className="font-normal md:font-semibold">
                              {item.city}
                            </span>
                          </div>
                        </Link>
                      </li>
                      <Divider className="my-3" marginless />
                    </>
                  ))}
                </ul>
              </div>
            )
          }
          return null
        })
      ) : (
        <NoResultsFound />
      )}
    </div>
  )
}
